import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useContext } from "react";
import { ValueComponentContext } from "../ComponentContext/ValueComponentContext";
import { LayoutGridType } from "../ReactPageLayout/LayoutGridType";
import { LayoutRows } from "../ReactPageLayout/LayoutRows";
import { PluginHelper } from "../ReactPageLayout/helpers/PluginHelper";
export function ValueCell(props) {
    var _a;
    const { node } = props;
    // lookup component for rendering values
    const components = useContext(ValueComponentContext);
    const pluginId = PluginHelper.getPluginId(node);
    const Component = (_a = components[pluginId]) !== null && _a !== void 0 ? _a : ValueComponentFallback;
    // map props for the component
    const valueTemplateProps = PluginHelper.getPluginProps(props.node);
    return (_jsx(Component, Object.assign({}, valueTemplateProps, { children: _jsx(LayoutRows, { rows: node.rows, gridType: LayoutGridType.Value }) })));
}
function ValueComponentFallback(props) {
    return _jsx(Fragment, { children: props.children });
}
//# sourceMappingURL=ValueCell.js.map